module.exports = __webpack_public_path__ + "static/img/app@2x.16bbbc8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/app@2x.png
// module id = qpfQ
// module chunks = 1